<template>
	<PortalPage :title="section.label">
		<PortalPlaceholder />
	</PortalPage>
</template>

<script setup lang="ts">
import PortalPage from '@/portal/components/PortalPage.vue'
import PortalPlaceholder from '@/portal/components/PortalPlaceholder.vue'
import { portalSection } from '@/portal/sections'

// The Help section's outlet page — the placeholder KOVA-800 replaces.
const section = portalSection('help')
</script>
